import type { TOC } from '@ember/component/template-only'
import { Tooltip } from 'teacher-ui-client/components/tooltip'
import PhosphorIcon from 'teacher-ui-client/components/phosphor-icon'
import { ContentTile } from 'teacher-ui-client/components/tiles/content'
import { or } from 'ember-truth-helpers'

interface Args {
  title?: string
  tooltip?: string
}

interface Signature {
  Element: Element
  Args: Args
  Blocks: {
    default: []
  }
}

export const StatBoxesTile: TOC<Signature> = <template>
  <ContentTile class="p-3" ...attributes>
    {{#if (or @title @tooltip)}}
      <div class="mb-1 flex items-baseline justify-between">
        {{#if @title}}
          <span class="font-semibold">{{@title}}</span>
        {{/if}}
        {{#if @tooltip}}
          <span class="print:hidden">
            <PhosphorIcon @icon="phosphor-info-fill" class="text-dusty-black-500 h-3 w-3 cursor-pointer" />
            <Tooltip @text={{@tooltip}} />
          </span>
        {{/if}}
      </div>
    {{/if}}
    {{yield}}
  </ContentTile>
</template>

export default StatBoxesTile
